import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  GetParamsForDocCreationRequest,
  GetParamsForDocCreationResponse,
} from "../../models/documentParams.model";

import { environment } from "../../environments";
import {
  ConvertDocumentTemplateRequest,
  ConvertDocumentTemplateResponse,
} from "../../models/convertDocumentTemplate.model";

const API_URL = environment.apiUrl;

export const getParamsForDocCreation = createAsyncThunk<
  GetParamsForDocCreationResponse,
  GetParamsForDocCreationRequest
>("document/getParamsForDocCreation", async (request, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_URL}Document/GetParamsForDocCreation`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(request),
    });
    const data: GetParamsForDocCreationResponse = await response.json();
    if (!data.success)
      return rejectWithValue(data.message || "Failed to fetch document params");
    return data;
  } catch (error: any) {
    return rejectWithValue(error.message || "Unknown error");
  }
});
export const convertDocumentTemplate = createAsyncThunk<
  ConvertDocumentTemplateResponse,
  ConvertDocumentTemplateRequest
>("document/convertDocumentTemplate", async (request, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_URL}Document/ConvertDocumentTemplate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Cache-Control": "no-cache, no-store, must-revalidate",
        Pragma: "no-cache",
        Expires: "0",
      },
      body: JSON.stringify(request),
    });
    const data: ConvertDocumentTemplateResponse = await response.json();
    if (!data.success)
      return rejectWithValue(data.message || "Failed to fetch document params");
    return data;
  } catch (error: any) {
    return rejectWithValue(error.message || "Unknown error");
  }
});
